import { AttachmentActions } from '../actions';

const initialState = {
  attachment: {},
  files: [],
};

const medicalAppointmentReducer = (
  state = initialState,
  action,
) => {
  switch (action.type) {
    case AttachmentActions.ACTION_SAVE_ATTACHMENT:
      state = {
        ...state,
        attachment: action.payload,
      };
      return state;
    case AttachmentActions.SET_ATTACHMENT_FILES:
      state = {
        ...state,
        files: action.payload,
      };
      return state;
    default:
      return state;
  }
};

export default medicalAppointmentReducer;
